import { useMutation } from 'react-query';

import { roleCreate } from 'api/endPoints/roleCreate';

export const useMutationCreateRole = () => {
    return useMutation<any, QueryError, IRoleNew>((params) => roleCreate(params));
};
